import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AdminRoutingModule } from './admin-routing.module';
import { LoginComponent } from './components/login/login.component';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { LayoutComponent } from './layout/layout.component';
import { FacilityListingComponent } from './components/facility-listing/facility-listing.component';
import { TableComponent } from './table/table.component';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatListModule } from '@angular/material/list';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { FacilityInfoComponent } from './components/facility-info/facility-info.component';
import { FacilityInfoLeftPanelComponent } from './components/facility-info-left-panel/facility-info-left-panel.component';
import { AuthModuleModule } from '../auth-module/auth-module.module';
import { CseListingComponent } from './components/cse-listing/cse-listing.component';
import { AddCseFormComponent } from './components/add-cse-form/add-cse-form.component';
import { RegCommonFormComponent } from '../auth-module/components/reg-common-form/reg-common-form.component';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CseMappedListComponent } from './components/cse-mapped-list/cse-mapped-list.component';
import { AddMappingFormComponent } from './components/add-mapping-form/add-mapping-form.component';
import { MatSelectModule } from '@angular/material/select';
import { MatPaginatorModule } from '@angular/material/paginator';
import { NgbPaginationModule } from '@ng-bootstrap/ng-bootstrap';
import { CseFacilityMappedComponent } from './components/cse-facility-mapped/cse-facility-mapped.component';
import { AdminDashboardComponent } from './components/admin-dashboard/admin-dashboard.component';
import { SharedModuleModule } from '../shared-module/shared-module.module';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { FilterComponent } from './filter/filter.component';
import { DownloadCsvComponent } from './download-csv/download-csv.component';

import {MatButtonModule} from '@angular/material/button';
import {MatDialogModule} from '@angular/material/dialog';
import { ExportDialogComponent } from './components/export-dialog/export-dialog.component';
import {MatTooltipModule} from '@angular/material/tooltip';
import { MapComponent } from './components/admin-dashboard/map/map.component';
import { IndiaMapComponent } from './components/admin-dashboard/india-map/india-map.component';
import { ScrollIntoViewDirective } from './scroll-into-view.directive';

@NgModule({
  declarations: [
    LoginComponent,
    SidebarComponent,
    LayoutComponent,
    FacilityListingComponent,
    TableComponent,
    FacilityInfoComponent,
    FacilityInfoLeftPanelComponent,
    CseListingComponent,
    AddCseFormComponent,
    CseMappedListComponent,
    AddMappingFormComponent,
    CseFacilityMappedComponent,
    AdminDashboardComponent,
    FilterComponent,
    DownloadCsvComponent,
    ExportDialogComponent,
    MapComponent,
    IndiaMapComponent,
    ScrollIntoViewDirective
  ],
  imports: [
    CommonModule,
    AdminRoutingModule,
    MatToolbarModule,
    MatDividerModule,
    MatIconModule,
    MatMenuModule,
    MatListModule,
    MatProgressSpinnerModule,
    AuthModuleModule,
    ReactiveFormsModule,
    FormsModule,
    MatSlideToggleModule,
    BrowserAnimationsModule,
    MatSelectModule,
    MatPaginatorModule,
    NgbPaginationModule,
    SharedModuleModule,
    MatFormFieldModule,
    MatInputModule,
    MatNativeDateModule,
    MatDatepickerModule,
    MatButtonModule,
    MatDialogModule,
    ReactiveFormsModule,
    MatTooltipModule
  ]
})
export class AdminModule { }
